export const enum TxUserColumnKey {
  contactName = 'contactName',
  txCenterName = 'txCenterName',
  role = 'role',
  email = 'email',
  primaryPhone = 'primaryPhone',
  isPrimary = 'isPrimary',
  secondaryPhone = 'secondaryPhone',
  status = 'status',
  isActive = 'isActive',
  actions = 'actions',
}

export const txUsersSortableColumnKeys: TxUserColumnKey[] = [TxUserColumnKey.contactName, TxUserColumnKey.email];
